import { setNonInsuredAddress } from "@/common/addresses";
import { parseApiAnswer } from "@/common/answers";
import {
  findMatchingOptionFromDependentQuestion,
  findAnswer,
} from "@/common/quotes";
import {
  checkAndUpdateVisibility,
  updateVisibilityBasedOn,
} from "@/common/visibility";
import store from "@/store/index";

export default {
  SET_SECTIONS(state, responseDataForm) {
    state.form.sections = responseDataForm.Sections;
  },
  SET_QUESTION_VISIBILITY(_, { getters, question }) {
    // Find any questions related to `question` and make them visible if
    // `question.value` matches the desired `condition`
    // E.g. this JSON on PaymentFrequency causes it to be visible
    //      if question 26 has a value of "DirectDebit":
    // Id: 27,
    // InterfaceKey: "PaymentFrequency"
    // IsVisible: false,
    // RelatedQuestionId: [26],
    // Conditions: ["DirectDebit"],
    getters.allQuestions.forEach((thisQuestion) => {
      if (
        thisQuestion.RelatedQuestionId &&
        thisQuestion.RelatedQuestionId.includes(question.Id)
      ) {
        updateVisibilityBasedOn(thisQuestion, question, getters.allQuestions);
        // if the question is not visible
        // we reset data related to the the question: ["MortgageInformation", "SolicitorInformation", "UseCorrespondenceAddress"]
        // AND the question is not, (these question has default value) ["EmailNotificationToSolicitor", "EmailAcceptToSolicitor"]
        if (
          thisQuestion.IsVisible === false &&
          (question.InterfaceKey === "MortgageInformation" ||
            question.InterfaceKey === "SolicitorInformation" ||
            question.InterfaceKey === "UseCorrespondenceAddress")
        ) {
          if (
            thisQuestion.InterfaceKey === "EmailNotificationToSolicitor" ||
            thisQuestion.InterfaceKey === "EmailAcceptToSolicitor"
          ) {
            thisQuestion.Value = "false";
            return;
          }
          if (!Array.isArray(thisQuestion.Value)) {
            if (thisQuestion.Questions) {
              thisQuestion.Questions.forEach((subItem) => (subItem.Value = ""));
            } else {
              thisQuestion.Value = "";
            }
          } else {
            thisQuestion.Value = [];
          }
        }
      }
    });
  },
  UPDATE_APPLY_RESPONSE(state, data) {
    state.applyResponse = data;
  },
  SET_ACTIVE_QUOTE(state, activeQuote) {
    state.activeQuote = activeQuote;
  },
  LOAD_RETRIEVED_QUOTE_DATA(state, { data }) {
    for (const section of state.form.sections) {
      if (!section.SubSections) continue;
      for (const subSection of section.SubSections) {
        for (const question of subSection.Questions) {
          if (question.Questions) {
            for (const innerQuestion of question.Questions) {
              setNonInsuredAddress(innerQuestion, data);
              if (
                innerQuestion.DependentValueCondition != null &&
                innerQuestion.Options?.length
              ) {
                const value = findMatchingOptionFromDependentQuestion(
                  data,
                  innerQuestion
                );
                if (value) {
                  innerQuestion.Value = value;
                }
              } else {
                const matchingAnswer = findAnswer(data, innerQuestion);
                if (!matchingAnswer) continue;
                innerQuestion.Value = matchingAnswer.Value;
                innerQuestion.Source = matchingAnswer.Source;
              }
            }
          }

          checkAndUpdateVisibility(question, subSection.Questions, data);

          if (
            question.DependentValueCondition != null &&
            question.Options?.length
          ) {
            const value = findMatchingOptionFromDependentQuestion(
              data,
              question
            );
            if (value) {
              question.Value = value;
            }
          } else {
            const matchingAnswer = findAnswer(data, question);
            if (!matchingAnswer) continue;
            question.Value = parseApiAnswer(matchingAnswer);
            question.Source = matchingAnswer.Source;
          }
        }
      }
    }
  },
  EXIT_TO_ADVISERHUB() {
    store.commit("questions/EXIT_TO_ADVISERHUB");
  },
  EXIT_TO_D2C_HOMEPAGE() {
    store.commit("questions/EXIT_TO_D2C_HOMEPAGE");
  },
  EXIT_TO_D2C_LANDLORD_WELCOME_PAGE() {
    store.commit("questions/EXIT_TO_D2C_LANDLORD_WELCOME_PAGE");
  },
  SET_CARD_PAYMENT_STATUS(state, data) {
    state.cardPaymentStatus = data;
  },
  SET_QUESTION_MAP(state, data) {
    state.questionMap = data;
  },
  SET_PAYMENT_ERROR_MESSAGE(state, data) {
    state.paymentErrorMessage = data;
  },
  CLEAR_PAYMENT_ERROR_MESSAGE(state) {
    state.paymentErrorMessage = "";
  },
  RESET_INVALID_QUESTIONS(state, { errors }) {
    Object.entries(errors).forEach(([key, value]) => {
      if (value && value.length) {
        if (state.questionMap[key]) {
          state.questionMap[key].Value = null;
        }
      }
    });
  },
};
